import React from 'react';

import { Box } from '@styleseat/ui';
import {
  BodyText,
  Stack,
  Bullet,
} from '../../../ui';

import { ProAppointmentDetails } from '../../../../api/Providers/Appointments';
import type { PublicProvider } from '../../../../api/Providers';

type MessageDetailsProps = {
  appointment: ProAppointmentDetails;
  provider: PublicProvider;
};

const MessageDetails:
React.FC<MessageDetailsProps> = ({
  appointment,
  provider,
}) => {
  const point = (
    <Box
      paddingX={8}
      top={-4}
    >
      <BodyText
        appearance="large"
      >
        •
      </BodyText>
    </Box>
  );

  const getFirstName = () => (appointment.client?.name.split(' ')[0]);
  const getArea = () => ((provider.locations && provider.locations[0]?.city) || 'your area');

  return (
    <Stack
      space={8}
    >
      <Bullet
        bulletIcon={point}
      >
        <BodyText
          weight="thin"
          testID="appointment_cancel_search_rank_impact_message_details_1"
        >
          {'We\'ll update our matching so that we don\'t send clients like this in the future'}
        </BodyText>
      </Bullet>
      <Bullet
        bulletIcon={point}
      >
        <BodyText
          weight="thin"
          testID="appointment_cancel_search_rank_impact_message_details_2"
        >
          {`${getFirstName()} won't be added to your client list and we'll turn off rebooking alerts`}
        </BodyText>
      </Bullet>
      <Bullet
        bulletIcon={point}
      >
        <BodyText
          weight="thin"
          testID="appointment_cancel_search_rank_impact_message_details_3"
        >
          {`We'll help ${getFirstName()} find a professional in ${getArea()} who's a better fit`}
        </BodyText>
      </Bullet>
    </Stack>
  );
};

export default MessageDetails;
